import type { HTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium',
  {
    variants: {
      tone: {
        neutral:
          'border-neutral-300 text-neutral-700 dark:border-neutral-700 dark:text-neutral-300',
        info: 'border-sky-300 text-sky-700 dark:border-sky-800 dark:text-sky-300',
        success:
          'border-emerald-300 text-emerald-700 dark:border-emerald-800 dark:text-emerald-300',
        warning: 'border-amber-300 text-amber-700 dark:border-amber-800 dark:text-amber-300',
        danger: 'border-red-300 text-red-700 dark:border-red-800 dark:text-red-300',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}

export { badgeVariants };
